import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvalidLinkComponent } from './invalid-link.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [InvalidLinkComponent],
  exports: [InvalidLinkComponent],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class InvalidLinkModule { }
